module.exports = __webpack_public_path__ + "static/media/Flights Fraud Demo.a4bd6273.mp4";